import { useState } from 'react';

interface ConfirmationConfig {
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  type?: 'danger' | 'warning' | 'info';
}

interface ConfirmationState extends ConfirmationConfig {
  isOpen: boolean;
  onConfirm: () => void;
}

export const useConfirmation = () => {
  const [confirmationState, setConfirmationState] = useState<ConfirmationState>({
    isOpen: false,
    title: '',
    message: '',
    onConfirm: () => {}
  });

  const showConfirmation = (config: ConfirmationConfig): Promise<boolean> => {
    return new Promise((resolve) => {
      setConfirmationState({
        ...config,
        isOpen: true,
        onConfirm: () => {
          setConfirmationState(prev => ({ ...prev, isOpen: false }));
          resolve(true);
        }
      });
    });
  };

  const hideConfirmation = () => {
    setConfirmationState(prev => ({ ...prev, isOpen: false }));
  };

  const handleCancel = () => {
    hideConfirmation();
    // Promise resolve etmediği için false dönmüş olur
  };

  return {
    confirmationState,
    showConfirmation,
    hideConfirmation,
    handleCancel
  };
}; 